module.exports = __webpack_public_path__ + "img/kitOrtodoncia.2be1961b.jpeg";